import { connect } from "react-redux";
import { createCampaign } from "../../../../store/action/campaignsAction";
import { Link, useNavigate } from "react-router-dom";
import { URL } from "../../../../routers/constants";

const NoCampaign = (props) => {
   const { createCampaign } = props;
   const navigate = useNavigate();

   return (
      <div id="bot-scene-content" className="scroll-light">
         <div className="header-live-stream-container app-v2-header-wrapper sale-post-list-header">
            <div className="header-live-stream-left-side">
               <div className="header-left-side-layout">
                  <div className="header-live-stream-title-container">
                     <div className="header-live-stream-title">
                        <div className="wrapper-header-title" title="Tin bán hàng">
                           <span className="title-header-live-stream">
                              Tin bán hàng
                           </span>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
         </div>
         <div className="livestream-intro hint-intro sale-post-intro">
            <div className="wrapper">
               <div className="left">
                  <label className="title">Tin bán hàng tự động</label>
                  <p className="description">Dễ dàng tạo kịch bản bán hàng theo sản phẩm tương ứng với bài viết.</p>
                  <p className="description">Nhận diện bình luận đúng cú pháp để hỗ trợ nhân viên tạo đơn thủ công hoặc giúp
                     khách hàng chốt đơn tự động và hoàn tất quy trình đặt hàng qua Messenger.</p>
                  <div className="action">
                     <Link to={URL.POSTS_COMMENTS_SALE_POSTS_SETTING}>
                        <button type="button" className="app-btn app-btn-primary button-add">
                           <div className="svg-next-icon mr8 ic-plus-2">
                           </div>
                           Tạo kịch bản
                        </button>
                     </Link>
                  </div>
               </div>
               <div className="right">
                  <div className="svg-next-icon icon-sale-post-intro">
                  </div>
               </div>
            </div>
         </div>
      </div>
   )
}

const mapStateToProps = () => {
   return {

   };
};

export default connect(mapStateToProps, {
   createCampaign
})(NoCampaign)
